import { makeAutoObservable } from 'mobx';
import { translator } from 'core/localization';
import { isValidHexColor } from 'controls/react/color-picker/colorPalettesStore';
import { MAX_COLORS_PER_PALETTE } from 'controls/react/color-picker/constants';
import { ModelValidator } from 'framework/mobx-integration';

const i18n = translator({
	'No valid hex colors found': { no: 'Fant ingen gyldige hex-farger' },
});

export class ImportPaletteFormStore {
	name: string = '';
	json: string = '';

	validator = new ModelValidator(this);

	constructor() {
		makeAutoObservable(this);

		this.validator.required('name').required('json');
		this.validator.add('json', {
			callback: () => {
				if (!this.json) return true;

				return this.validColors.length > 0;
			},
			message: i18n('No valid hex colors found'),
		});
	}

	destroy = () => {};

	// Accepts either a JSON array of hex colors, or a plain comma-separated list -
	// whichever the pasted text turns out to be.
	get parsedColors(): string[] {
		const trimmed = this.json.trim();
		if (!trimmed) return null;

		try {
			const data: unknown = JSON.parse(trimmed);
			if (Array.isArray(data)) return data as string[];
		} catch {
			// not JSON - fall through to comma-separated parsing
		}

		return trimmed
			.split(',')
			.map((x) => x.trim())
			.filter((x) => x.length > 0);
	}

	get validColors(): string[] {
		return (this.parsedColors ?? []).filter((x) => typeof x === 'string' && isValidHexColor(x));
	}

	get truncated(): boolean {
		return this.validColors.length > MAX_COLORS_PER_PALETTE;
	}

	closeModal: (result: boolean) => void;
}
